import { lazy } from 'react'
import { Navigate, useRoutes } from 'react-router-dom'
import { retry } from '../common/utils/CommonFunctions'
import { useAuthContext } from '../hooks/useAuthContext'

const Sidebar = lazy(() => retry(() => import('../layout/Sidebar')))
const Login = lazy(() => retry(() => import('../pages/Login')))
const FourOhFourHome = lazy(() =>
  retry(() => import('../pages/FourOhFourHome')),
)

const Routes = () => {
  const { token } = useAuthContext()

  const routes = useRoutes([
    {
      path: '/',
      element: <Navigate replace to="/admin/users" />,
    },
    {
      path: '/admin/login',
      element: !token ? <Login /> : <Navigate replace to="/admin/users" />,
    },
    {
      path: '/admin/*',
      element: token ? <Sidebar /> : <Navigate replace to="/admin/login" />,
    },
    {
      path: '/admin/*',
      element: <Navigate replace to="/admin/404" />,
    },
    {
      path: '/admin/404',
      element: <FourOhFourHome />,
    },
    {
      path: '/*',
      element: <FourOhFourHome />,
    },
  ])

  return routes
}

export default Routes
